import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a560d8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"90%"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center align-items-center p-3 h-full text-center" }, " 休日はありません。追加するには下の「追加する」ボタンをクリックしてください ", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "flex justify-content-center my-3",
  style: {"width":"100%"}
}
const _hoisted_5 = { class: "circle-index z-index-1 absolute ml-2 top-0 left-0" }
const _hoisted_6 = { class: "w-100 flex justify-content-between align-items-center" }
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = { class: "text-sm ml-2" }
const _hoisted_9 = { class: "text-sm ml-2" }

import { ref, reactive, computed, nextTick } from "vue";
import { useStore } from "vuex";
import { get, set } from "@vueuse/core";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import DayOffSelectComponent from "./day-off-select.vue";
import moment from "moment";
import { StaffServices } from "@/clinic/services";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import { ApiStaffTimeOffsCreateReq, StaffTimeOff } from "@/clinic/typings";
import _ from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'dialog-staff-time-off',
  emits: ["refetchCalendarResources", "reFetchRemainningSlot"],
  setup(__props, { expose, emit: emits }) {

const store = useStore();
const toast = useToast();
const confirm = useConfirm();


const staff = ref();
const visible = ref(false);
const showRegisterButton = ref(false);
const formRef = ref<HTMLFormElement>();
const formContainer = ref<HTMLFormElement>();
const timeZone = ref("Asia/Tokyo");

const staffDayOffData = reactive<any>({ time_offs: {}, day_offs: [] });

const refetchCalendar = () => {
  emits("reFetchRemainningSlot");
  emits("refetchCalendarResources");
};

const selectedDate = computed(() => staffDayOffData.day_offs.map((day: string) => moment(day).toDate()));
const dayOffsNumber = computed(() => staffDayOffData.day_offs.length);
const timeOffsNumber = computed(
  () =>
    Object.values(staffDayOffData.time_offs)
      .flat()
      .filter((time: any) => !time.destroy).length
);

const showDialog = () => {
  staffDayOffData.day_offs = [];
  staffDayOffData.time_offs = {};
  set(visible, true);
};
const hideDialog = () => set(visible, false);

const addDayoff = (day?: string, timeOffs?: StaffTimeOff[]) => {
  const today = moment().format("YYYY-MM-DD");
  const getLatestDate = () => {
    if (day) return day;
    if (staffDayOffData.day_offs.length === 0) return today;

    const latestDate = moment(Math.max(...staffDayOffData.day_offs.map((t: string) => moment(t).toDate()))).add(
      1,
      "days"
    );
    if (latestDate.isBefore(moment())) return today;

    return latestDate.format("YYYY-MM-DD");
  };

  const latestDate = getLatestDate();

  if (staffDayOffData.day_offs.length === 0) {
    set(showRegisterButton, true);
  }

  staffDayOffData.day_offs.unshift(latestDate);

  if (timeOffs) {
    staffDayOffData.time_offs[latestDate] = timeOffs;
  } else {
    const defaultTimeOff = {
      from: moment(latestDate).set({ hour: 8, minute: 0 }).toDate(),
      to: moment(latestDate).set({ hour: 17, minute: 0 }).toDate(),
    };
    Object.keys(staffDayOffData.time_offs).includes(latestDate)
      ? staffDayOffData.time_offs[latestDate].push(defaultTimeOff)
      : (staffDayOffData.time_offs[latestDate] = [defaultTimeOff]);
    nextTick(() => {
      formContainer.value.scrollTop = 0;
    });
  }
};
const addTimeOff = (day: string, time_off: StaffTimeOff) => {
  if (
    !staffDayOffData.time_offs[day]
      .filter((t: StaffTimeOff) => !t.destroy)
      .some(
        (item: StaffTimeOff) =>
          map_YMD_HM(item.from) == map_YMD_HM(time_off.from) &&
          map_YMD_HM(item.to) == map_YMD_HM(time_off.to) &&
          item.position == time_off.position
      )
  ) {
    staffDayOffData.time_offs[day].push(time_off);
  }
};
const deleteDayOff = (day: string) => {
  const existed_time_offs = staffDayOffData.time_offs[day].filter((t: any) => t.id && t.id.length > 0);
  if (existed_time_offs && existed_time_offs.length > 0) {
    staffDayOffData.time_offs[day] = JSON.parse(JSON.stringify(existed_time_offs));
    staffDayOffData.time_offs[day].forEach((t: any) => {
      t.destroy = true;
      t.from = moment(t.from).toDate();
      t.to = moment(t.to).toDate();
    });
  } else {
    delete staffDayOffData.time_offs[day];
  }
  staffDayOffData.day_offs = staffDayOffData.day_offs.filter((d: string) => d !== day);

  if (Object.keys(staffDayOffData.time_offs).length === 0) {
    set(showRegisterButton, false);
  }
};
const deleteTimeOff = (day: string, time_off: StaffTimeOff) => {
  if (!time_off.id) {
    const deletedIndex = staffDayOffData.time_offs[day].indexOf(time_off);
    staffDayOffData.time_offs[day].splice(deletedIndex, 1);

    let count = 1;
    staffDayOffData.time_offs[day].forEach((time: StaffTimeOff) => {
      if (!time.destroy) {
        time.position = count++;
      }
    });
  }
};

const validate = (existedRanges: boolean, validRanges: boolean) =>
  set(showRegisterButton, existedRanges && validRanges);
const map_YMD_HM = (date: string) => moment(date).format("YYYY-MM-DD hh:mm");
const setGeneralInfo = (data: any) => set(staff, data);

const fetchStaffTimeOffs = async () => {
  const res = await StaffServices.getTimeOffs({
    clinic_id: store.getters["authClient/selectedClinic"].id,
    staff_id: staff.value.id,
  });

  const times = get(res).data.value;
  if (times) {
    const days = Object.keys(times);
    if (days.length > 0) {
      set(showRegisterButton, true);
      staffDayOffData.day_offs = days;

      const formattedData = {};
      staffDayOffData.day_offs.forEach((day: any) => {
        formattedData[day] = times[day].map((time: any) => ({
          id: time.id,
          from: convertedTimezoneDate(time.from, get(timeZone)),
          to: convertedTimezoneDate(time.to, get(timeZone)),
        }));
        formattedData[day].reverse();
      });
      staffDayOffData.time_offs = formattedData;
    } else {
      set(showRegisterButton, false);
    }
  }
};
const createTimeOffs = () => {
  confirm.require({
    message: "設定を更新します。よろしいですか？",
    header: "設定の確認",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button-warning",
    accept: async () => {
      await StaffServices.createTimeOffs(
        getCreateTimeOffsPayload(),
        () => {
          hideDialog();
          notifySuccessMsg(toast, "成功");
          refetchCalendar();
        },
        (error: any) => {
          notityErrorMsg(toast, error.response.data);
        }
      );
    },
  });
};
const getCreateTimeOffsPayload = () => {
  const time_offs = _.cloneDeep(Object.values(staffDayOffData.time_offs).flat());
  time_offs.forEach((t: any) => {
    t.from = changedTimezoneDate(t.from, get(timeZone));
    t.to = changedTimezoneDate(t.to, get(timeZone));
  });
  return {
    clinic_id: store.getters["authClient/selectedClinic"].id,
    staff_id: Number(staff.value.id),
    time_offs: time_offs,
  } as ApiStaffTimeOffsCreateReq;
};
const changedTimezoneDate = (date: any, tz: any) => {
  const momentDate = moment(date);
  const d = new Date(
    Date.UTC(momentDate.year(), momentDate.month(), momentDate.date(), momentDate.hour(), momentDate.minute())
  );
  return moment(dateWithTimezone(d, tz)).toDate();
};
const dateWithTimezone = (date: Date, fromTimeZone: any) => {
  const utcDate = new Date(date.toLocaleString("en-US", { timeZone: "UTC" }));
  const tzDate = new Date(date.toLocaleString("en-US", { timeZone: fromTimeZone }));
  const offset = utcDate.getTime() - tzDate.getTime();
  date.setTime(date.getTime() + offset);

  return date;
};
const convertedTimezoneDate = (date: any, tz: any) => {
  return moment(moment(date).toDate().toLocaleString("en-US", { timeZone: tz })).toDate();
};
// eslint-disable-next-line no-undef
expose({
  showDialog,
  fetchStaffTimeOffs,
  setGeneralInfo,
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    modal: "",
    header: `休日を設定 ー ${staff.value?.title}`,
    draggable: false,
    contentClass: "px-0",
    style: {"width":"55%"}
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            label: "追加する",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addDayoff()))
          }),
          _createElementVNode("div", _hoisted_8, "休日数: " + _toDisplayString(staffDayOffData.day_offs.length), 1),
          _createElementVNode("div", _hoisted_9, " 休日シフト数: " + _toDisplayString(_unref(timeOffsNumber)), 1)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            label: "キャンセル",
            class: "p-button-light mr-1",
            onClick: hideDialog
          }),
          _createVNode(_component_Button, {
            label: "保存",
            class: "text-white",
            onClick: createTimeOffs,
            disabled: !showRegisterButton.value
          }, null, 8, ["disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "form-container overflow-scroll",
        ref_key: "formContainer",
        ref: formContainer
      }, [
        _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
          [_vShow, _unref(dayOffsNumber) == 0]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            ref_key: "formRef",
            ref: formRef,
            style: {"width":"75%"}
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staffDayOffData.day_offs, (day, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: day,
                class: "relative"
              }, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(staffDayOffData.day_offs.length - index), 1),
                _createVNode(DayOffSelectComponent, {
                  onOnDeleteDate: deleteDayOff,
                  onOnDeleteTime: deleteTimeOff,
                  onOnAddTime: addTimeOff,
                  onOnChangeDate: addDayoff,
                  onOnValidate: validate,
                  timeOffs: staffDayOffData.time_offs[day],
                  day: day,
                  disabledDates: _unref(selectedDate)
                }, null, 8, ["timeOffs", "day", "disabledDates"])
              ]))
            }), 128))
          ], 512)
        ])
      ], 512)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})